import useAlert from "hooks/useAlert";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import useMetaManager from "hooks/useMetaManager";
import { useState } from "react";
import mapDataFactory from "utils/mapDataFactory";
import { Blog } from "utils/types";
import ItemList from "./ItemList";
import Spinner from "./utils/Spinner";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

interface blogsMeta {
  banners?: number[];
  editorPicks?: number[];
}

const BlogsSiteSection = () => {
  const axios = useAxiosPrivate();

  const queryClient = useQueryClient();

  const { setAlert } = useAlert();

  //Blogs
  //TODO : add loading for blog banner and editor picks

  const { data: banners, status: bannersStatus } = useQuery(
    ["blogs", "banners"],
    async () => {
      const { data } = await axios.get<Blog[]>("/blogs/banners");
      return data;
    }
  );

  const { data: editorPicks, status: editorPicksStatus } = useQuery(
    ["blogs", "editor-picks"],
    async () => {
      const { data } = await axios.get<Blog[]>("/blogs/editor-picks");
      return data;
    }
  );

  const { mutate: mutateBlogMeta } = useMutation(
    (data: blogsMeta) => axios.post("/blogs/meta", data),
    {
      onSuccess: () => {
        setAlert("success", "Changes saved");
        queryClient.invalidateQueries(["blogs", "banners"]);
        queryClient.invalidateQueries(["blogs", "editor-picks"]);
      },
      onError: () => {
        setAlert("error", "Something went wrong");
      },
    }
  );

  return (
    <div className="shadow-sm bg-white rounded-md p-4 relative">
      <h2 className="text-2xl text-gray-700">Blogs</h2>
      <hr className="my-2" />
      <h3 className="text-xl text-gray-700 mb-2 mt-4">Banners</h3>
      {bannersStatus === "loading" ? (
        <Spinner />
      ) : bannersStatus === "error" ? (
        <div>Something went wrong, Reload the page</div>
      ) : (
        <div>
          <ItemList
            url="/blogs"
            maxLength={8}
            items={banners}
            onPick={(targetId) => {
              if (banners.some((el) => el.id === targetId)) {
                setAlert("error", "Cant choose duplicate items");
                return;
              }
              mutateBlogMeta({
                banners: [...banners.map((b) => b.id), targetId],
              });
            }}
            onDelete={(id) =>
              mutateBlogMeta({
                banners: banners.filter((b) => b.id !== id).map((b) => b.id),
              })
            }
          />
        </div>
      )}
      
      <h3 className="text-xl text-gray-700 mb-2 mt-4">Editor's Pick</h3>
      {editorPicksStatus === "loading" ? (
        <Spinner />
      ) : editorPicksStatus === "error" ? (
        <div>Something went wrong, Reload the page</div>
      ) : (
        <div>
          <ItemList
            url="/blogs"
            maxLength={8}
            items={editorPicks}
            onPick={(targetId) => {
              if (editorPicks.some((el) => el.id === targetId)) {
                setAlert("error", "Cant choose duplicate items");
                return;
              }
              mutateBlogMeta({
                editorPicks: [...editorPicks.map((b) => b.id), targetId],
              });
            }}
            onDelete={(id) =>
              mutateBlogMeta({
                editorPicks: editorPicks.filter((b) => b.id !== id).map((b) => b.id),
              })
            }
          />
        </div>
      )}
      
    </div>
  );
};

export default BlogsSiteSection;
